export const DISCONTINUED_STORE_FORMATS = ['050', '070', '080', '088'] as const;

export const isDiscontinuedStoreFormat = (storeFormat?: string) =>
    DISCONTINUED_STORE_FORMATS.some((format) => format === storeFormat);
